import $ from 'jquery'
import Emitter from 'events'

/* 
  https://sheets.googleapis.com/v4/spreadsheets/1muiQMIIZEj14d_2C-KJhYoZP6opRTJTlTQkmxPRWHUE/values/Sheet1?alt=json&key=AIzaSyB6Mt2hVNe_9mOCImmtq_cJXAwUX6qa1DY
  
  filibuster sheet id: 1Lx5G6WjKsZhkl4_4bFtn7MaXWzRTkhp5GeqtUyXEJ0Y
  roe sheet id:  1muiQMIIZEj14d_2C-KJhYoZP6opRTJTlTQkmxPRWHUE
*/
class SheetsDataFetcher {
  constructor() {
    this._emitter = new Emitter()
  }
  fetch(sheetID) {
    /*
    multiple components might fetch the same sheet
    no need to do that more than once though, they all listen to the emitter
    see filibuster-components.js for example
    */
    if (this[`fetching-${sheetID}`]) return
    this[`fetching-${sheetID}`] = true

    const url =
      'https://sheets.googleapis.com/v4/spreadsheets/' +
      sheetID +
      '/values/' +
      'Sheet1' +
      '?alt=json&key=' +
      'AIzaSyB6Mt2hVNe_9mOCImmtq_cJXAwUX6qa1DY'
    $.getJSON(url).then(
      (data) => {
        // console.log('success fetching data')
        this[`data-${sheetID}`] = data
        this._emitter.emit('response', data)
        this[`fetching-${sheetID}`] = false
      },
      (data) => {
        // console.log('error fetching data')
        this.error = true
        this._emitter.emit('response', null)
        this[`fetching-${sheetID}`] = false
      }
    )
  }
}

const instance = new SheetsDataFetcher()
window.tpm_sheetsdatafetcher = instance

export default instance
